<script>
import mixinLabel from '../../../mixins/graphics/mixinLabel'
import mixinGraphic from '../../../mixins/graphics/mixinGraphic'

export default {
  name: 'vc-graphics-label',
  mixins: [mixinLabel, mixinGraphic]
}
</script>
